import React from 'react';
import { Container, Header, Transition } from 'semantic-ui-react';

import FormularioCrearCompromiso from './FormularioNuevoComentario';
import TarjetaCompromisoDePago from './TarjetaCompromisoDePago';
import TarjetaObservacion from './TarjetaObservacion';
import TarjetaRetiro from './TarjetaRetiro';
import { mapaDeTitulos, TipoCompromiso, TipoNuevoCompromiso, TiposDeObservacionId } from './tipos';

interface Props {
    readonly observaciones: ReadonlyArray<TipoCompromiso>;
    alRegistrarObservacion(compromiso: TipoNuevoCompromiso): Promise<void>;
    alEliminarObservacion(compromiso: TipoCompromiso): void;
}

const Compromisos: React.FunctionComponent<Props> = props => {
    const { observaciones, alRegistrarObservacion, alEliminarObservacion } = props;
    return (
        <Container text>
            <FormularioCrearCompromiso alRegistrarCompromiso={alRegistrarObservacion} />

            <Header as='h3'>
                {observaciones.length
                    ? 'Observaciones registradas'
                    : 'No hay observaciones registradas'}
            </Header>

            <Transition.Group animation='fade up' duration={300}>
                {observaciones.map((compromiso, i) => {
                    const Componente = elegirComponenteParaElComentario(compromiso);
                    const titulo =
                        compromiso.tipo === 'otro' ? 'Observación' : mapaDeTitulos[compromiso.tipo];
                    return (
                        <Componente
                            key={`${compromiso.fechaDeRegistro}${i}`}
                            titulo={titulo}
                            alEliminar={() => alEliminarObservacion(compromiso)}
                            {...compromiso}
                        />
                    );
                })}
            </Transition.Group>
        </Container>
    );
};

function elegirComponenteParaElComentario(compromiso: {
    tipo: TiposDeObservacionId;
    // tslint:disable-next-line:no-any
}): React.ComponentType<any> {
    if (compromiso.tipo === 'compromiso') return TarjetaCompromisoDePago;
    if (compromiso.tipo === 'retiro') return TarjetaRetiro;
    return TarjetaObservacion;
}

export default Compromisos;
export * from './tipos';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Observaciones/index.tsx